module.exports = __webpack_public_path__ + "img/ar_get.5d838e2.png";